// extracted by mini-css-extract-plugin
export default {"promoLogo":"ProductsPage--promoLogo--30GBq"};